
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexaxhXfpyqT4NsbGwQYREAPZJDtf8PS6gvABzsNsm4Lt8Meta } from "/baserow/web-frontend/modules/core/pages/index.vue?macro=true";
import { default as debugyfJbe3SH99sjlb72Kkr8EE8sTi_CjDBVzv6TP1k2sxIMeta } from "/baserow/web-frontend/modules/core/pages/debug.vue?macro=true";
import { default as loginFAm3yEfyhBwXZT1Kk5blIo0Bz3KhwZt9JSfKwPqDV5YMeta } from "/baserow/web-frontend/modules/core/pages/login.vue?macro=true";
import { default as signup5zPoVaIvPpLeg5gyAd4731QLyxH7xerVN8juC1jVwEUMeta } from "/baserow/web-frontend/modules/core/pages/signup.vue?macro=true";
import { default as freeTrialPaNndZq_fSFY4ckX2jcTIvSReqFyBrao32Lo1ze7o8YMeta } from "/baserow/web-frontend/modules/core/pages/freeTrial.vue?macro=true";
import { default as forgotPasswordvXKtJeFLefU_eoe64zxif8ad65BY6NBtU0fppkJzGssMeta } from "/baserow/web-frontend/modules/core/pages/forgotPassword.vue?macro=true";
import { default as resetPasswordgzx4JcLeGDrTL0LGxk2cxGcky_t8NSKi5xGNBToKN4MMeta } from "/baserow/web-frontend/modules/core/pages/resetPassword.vue?macro=true";
import { default as changeEmail95orio502yhvxW97MRanGTZ5Yo_xae5I1XELCZQeWjQMeta } from "/baserow/web-frontend/modules/core/pages/changeEmail.vue?macro=true";
import { default as verifyEmailAddressR2OIsgQpZq9ysYjgT_45w9qMQGGBC_45S8k9hDFFWzbhWQQMeta } from "/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue?macro=true";
import { default as styleGuideExVXvsJ3W1KXsW3bmJMH6ipKKa_PI5mKwrEwZjH8mqcMeta } from "/baserow/web-frontend/modules/core/pages/styleGuide.vue?macro=true";
import { default as loginWithSAMLvM_z4O38tmHk9YjScjMQkEKvXviBIicsRg6aqSuEtn8Meta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue?macro=true";
import { default as loginErrorLHL3wiyPXp5pSQcumQUa0XXyCPbKAaHmRxCP5unWMBsMeta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue?macro=true";
import { default as loginPages00XrtcxiWyqJDnUxEYy6Uxi6YfkQq4R2BSx1XHjdPRsMeta } from "/baserow/web-frontend/modules/core/pages/loginPages.vue?macro=true";
import { default as dashboardP9ZS90vKuR9tMEFMPVURylNqCsLSxJThcsL3HLp_ZSYMeta } from "/baserow/web-frontend/modules/core/pages/dashboard.vue?macro=true";
import { default as workspacexI8X5yce_45VJjZC2PMQsciD8pRGqstrAvFg3ge33VH1EMeta } from "/baserow/web-frontend/modules/core/pages/workspace.vue?macro=true";
import { default as docsgvMFazicZwK1mSLQMiVDZi096iJKqsR5qBb9EUHiR00Meta } from "/baserow/web-frontend/modules/core/pages/docs.vue?macro=true";
import { default as docsArticle0u_h_45InRUAIAsg3wHxt2jIgYCKRL4CtC0G5lxk0kS8wMeta } from "/baserow/web-frontend/modules/core/pages/docsArticle.vue?macro=true";
import { default as settingsp3BJh13Fkfb0KZaPmKCLHJXR34vhLG0ugRZmlOQlarAMeta } from "/baserow/web-frontend/modules/core/pages/admin/settings.vue?macro=true";
import { default as healthLmxBHCxJEJN3OOGKt783EuMz3rDeFx8x4yjmB12c_458cMeta } from "/baserow/web-frontend/modules/core/pages/admin/health.vue?macro=true";
import { default as dashboardPM5OfxM2I_WNSjJDAXpAjm6GeihmhmikHC4BUFkTkhQMeta } from "/baserow/web-frontend/modules/core/pages/admin/dashboard.vue?macro=true";
import { default as userspOsYPes4mnwNxzSpRgVjZ0ZEqDxX0cQbIt94uq3OVVYMeta } from "/baserow/web-frontend/modules/core/pages/admin/users.vue?macro=true";
import { default as workspaces2_45B16HKKK2NlwG3NHttrsWorJR7G1FKpgCpCs0QQAjsMeta } from "/baserow/web-frontend/modules/core/pages/admin/workspaces.vue?macro=true";
import { default as membersCVzdOebWZW7OVoeIsfJI4_DL_45pv3L3pICwQvuMYcWPAMeta } from "/baserow/web-frontend/modules/core/pages/settings/members.vue?macro=true";
import { default as invitesz8xPsfHUXjdeCvi_zrqZPD4JN8lXmH0ExxQmxS4pMlUMeta } from "/baserow/web-frontend/modules/core/pages/settings/invites.vue?macro=true";
import { default as teamsPn8hGwg_Zpwf_45D_45TY8_kJB1lwMQ5GfMf0FtXiYlHDmsMeta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue?macro=true";
import { default as settingsczUr56MC1ztfUOvKf3Qu6ZMMPL76mVY7CJ0_FZMk7bwMeta } from "/baserow/web-frontend/modules/core/pages/settings.vue?macro=true";
import { default as authProvidersuMb14F76shjkmDTzRgx9t1Byy96DUtu2UGSPdf2s0YIMeta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue?macro=true";
import { default as auditLoghW_1xgi9QvuDiwKn1VN8riwHG3scPWGWzYm_ix4l_45mEMeta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue?macro=true";
import { default as scans_fg4IZ2ADQ1iD7Focql8piB0FZYub5xoxKeDmJocCqEMeta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/scans.vue?macro=true";
import { default as resultsbs9ZquoyfDNndHlh1ezASO_45RpfsarceSQflfLLVGltsMeta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/results.vue?macro=true";
import { default as dataScanner_456g9jC3fPyQ_h8Rdz0ov8pHnlbQ3UwPk_45kQsxyM9EaIMeta } from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue?macro=true";
import { default as rootwE5HkpLoNnv48j44rpJNvZiEagcsWLtMNVcx8P0w0LcMeta } from "/baserow/web-frontend/modules/core/pages/root.vue?macro=true";
import { default as workspaceInvitation0bgeDZxpATWgk_Ol9JAToxj_1ngagMW2Pt76KzJKA88Meta } from "/baserow/web-frontend/modules/core/pages/workspaceInvitation.vue?macro=true";
import { default as workspaceSubscriptionFEts0rEHl6Uz5DM7PwO3g1xaYeB7S90dSqMpNPxKhoAMeta } from "/baserow/web-frontend/modules/core/pages/workspaceSubscription.vue?macro=true";
import { default as templateSKj4xZ68R0PZM1AHpCQfExSLvTmfj6ENWUufXtXfRVoMeta } from "/baserow/web-frontend/modules/core/pages/template.vue?macro=true";
import { default as _health3VjDon_45QO_xWkP_pVeU9wrbLvv8SqSDMJ30zB6hg_45jcMeta } from "/baserow/web-frontend/modules/core/pages/_health.vue?macro=true";
import { default as notificationRedirectGXpBKUmTunQaKL7Sy_L_MP41DhVEOLCJlrlfWIDdKAMMeta } from "/baserow/web-frontend/modules/core/pages/notificationRedirect.vue?macro=true";
import { default as onboardingIWNjSFyY6nPF_BVSHjJTVK5hBIMIe612LISdhdjMObUMeta } from "/baserow/web-frontend/modules/core/pages/onboarding.vue?macro=true";
import { default as RouterViewPlaceholderwJRsCrERj4QMBOYr56dCRHLTtGJ0SLcVMrCLRh3ooMIMeta } from "/baserow/web-frontend/modules/core/components/RouterViewPlaceholder.vue?macro=true";
import { default as webhooksrOeM4AdDGpn2Eedu67L2Gmzve4XcjP_ki7E86DBoSYsMeta } from "/baserow/web-frontend/modules/database/pages/table/webhooks.vue?macro=true";
import { default as configureDataSync8vJuQ8fp_45dHxFROfMrEH98wDULOthVMu8bR8Dm0DXmoMeta } from "/baserow/web-frontend/modules/database/pages/table/configureDataSync.vue?macro=true";
import { default as tablemTVQiEMlU14K5OtkWdYaGXkjm3tVCiQtx2LsdJnfk_QMeta } from "/baserow/web-frontend/modules/database/pages/table.vue?macro=true";
import { default as APIDocsQg8DLE1eQadmdbWaqyCWLfVyuLfYC7LYtjxAWhrpEfoMeta } from "/baserow/web-frontend/modules/database/pages/APIDocs.vue?macro=true";
import { default as APIDocsDatabaseR_p4hKFw3a_FqJtxCtkNa67Y9pDlAolaDW81M_45UnHwcMeta } from "/baserow/web-frontend/modules/database/pages/APIDocsDatabase.vue?macro=true";
import { default as formw_BzpJ6zuRLPVhUiY1V7u_nV5ze1MyIRbzwlCtEjzEUMeta } from "/baserow/web-frontend/modules/database/pages/form.vue?macro=true";
import { default as publicViewGhjPj1u2XO5Pay8rzYFlcVzjH8CiDPNVBd41F_GrDdIMeta } from "/baserow/web-frontend/modules/database/pages/publicView.vue?macro=true";
import { default as publicViewLoginKVr__4_4550hOAzx59hzmTOxTyOoxVZ9_zBS_rYEgf3REMeta } from "/baserow/web-frontend/modules/database/pages/publicViewLogin.vue?macro=true";
import { default as dashboardj_EB_Il_Josd1bmESPebSB_f1OHa9fmmpy9FJpVgJ8MMeta } from "/baserow/web-frontend/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as pageEditorsZQzKZbfo1k6Gkb3KmAv47XyUSeGMH4gZEDTslcIlcMMeta } from "/baserow/web-frontend/modules/builder/pages/pageEditor.vue?macro=true";
import { default as publicPagen9QQo_45OzKGyFw_uoQo9eDF2skR0eekVB7NagugW19YgMeta } from "/baserow/web-frontend/modules/builder/pages/publicPage.vue?macro=true";
import { default as automationWorkflowhCau8gUYQvK_45lD1Mi3_M_K9P71VIvnTqxqIf_ZfEsMMMeta } from "/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue?macro=true";
import { default as licensesmzDgoW2_45voHJynKYUXMaKeoVi1FLMyphQLy6TQ0AOgAMeta } from "/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue?macro=true";
import { default as licensec24WGnNG4lqaJzipKZtk5QEcsxnOi_Dq1t1Fpe8C1DAMeta } from "/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue?macro=true";
import { default as rootOhF6Qibb72QLTvpk0YXBFRpkCuwCr_OzDVjK8lo3riYMeta } from "/baserow/premium/web-frontend/modules/baserow_premium/pages/root.vue?macro=true";
import { default as publicViewic0BLFnKa9D79LeCccGHGRa0RQ5dtQAxboPDW3rHy9wMeta } from "@baserow/modules/database/pages/publicView.vue?macro=true";
export default [
  {
    name: "index",
    path: "",
    component: () => import("/baserow/web-frontend/modules/core/pages/index.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/baserow/web-frontend/modules/core/pages/debug.vue")
  },
  {
    name: "login-pages",
    path: "",
    meta: { ...(loginPages00XrtcxiWyqJDnUxEYy6Uxi6YfkQq4R2BSx1XHjdPRsMeta || {}), ...{"middleware":["settings","urlCheck","settings","urlCheck"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/loginPages.vue"),
    children: [
  {
    name: "login",
    path: "/login",
    meta: { ...(loginFAm3yEfyhBwXZT1Kk5blIo0Bz3KhwZt9JSfKwPqDV5YMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signup5zPoVaIvPpLeg5gyAd4731QLyxH7xerVN8juC1jVwEUMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/signup.vue")
  },
  {
    name: "free-trial",
    path: "/teste-gratis",
    meta: { ...(freeTrialPaNndZq_fSFY4ckX2jcTIvSReqFyBrao32Lo1ze7o8YMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/freeTrial.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgotPasswordvXKtJeFLefU_eoe64zxif8ad65BY6NBtU0fppkJzGssMeta || {},
    component: () => import("/baserow/web-frontend/modules/core/pages/forgotPassword.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/baserow/web-frontend/modules/core/pages/resetPassword.vue")
  },
  {
    name: "change-email",
    path: "/change-email/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/baserow/web-frontend/modules/core/pages/changeEmail.vue")
  },
  {
    name: "verify-email-address",
    path: "/verify-email-address/:token",
    meta: verifyEmailAddressR2OIsgQpZq9ysYjgT_45w9qMQGGBC_45S8k9hDFFWzbhWQQMeta || {},
    component: () => import("/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/baserow/web-frontend/modules/core/pages/styleGuide.vue")
  },
  {
    name: "login-saml",
    path: "/login/saml",
    meta: loginWithSAMLvM_z4O38tmHk9YjScjMQkEKvXviBIicsRg6aqSuEtn8Meta || {},
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue")
  },
  {
    name: "login-error",
    path: "/login/error",
    meta: loginErrorLHL3wiyPXp5pSQcumQUa0XXyCPbKAaHmRxCP5unWMBsMeta || {},
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue")
  }
]
  },
  {
    name: "root",
    path: "",
    meta: { ...(rootwE5HkpLoNnv48j44rpJNvZiEagcsWLtMNVcx8P0w0LcMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/root.vue"),
    children: [
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardP9ZS90vKuR9tMEFMPVURylNqCsLSxJThcsL3HLp_ZSYMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/dashboard.vue")
  },
  {
    name: "workspace",
    path: "/workspace/:workspaceId",
    meta: { ...(workspacexI8X5yce_45VJjZC2PMQsciD8pRGqstrAvFg3ge33VH1EMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","settings","authenticated","impersonate","workspacesAndApplications"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/workspace.vue")
  },
  {
    name: "docs",
    path: "/docs",
    meta: { ...(docsgvMFazicZwK1mSLQMiVDZi096iJKqsR5qBb9EUHiR00Meta || {}), ...{"middleware":["settings","authenticated","impersonate","settings","authenticated","impersonate"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/docs.vue")
  },
  {
    name: "docs-article",
    path: "/docs/:slug",
    meta: { ...(docsArticle0u_h_45InRUAIAsg3wHxt2jIgYCKRL4CtC0G5lxk0kS8wMeta || {}), ...{"middleware":["settings","authenticated","impersonate","settings","authenticated","impersonate"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/docsArticle.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/baserow/web-frontend/modules/core/pages/admin/settings.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(healthLmxBHCxJEJN3OOGKt783EuMz3rDeFx8x4yjmB12c_458cMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow/web-frontend/modules/core/pages/admin/health.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/baserow/web-frontend/modules/core/pages/admin/dashboard.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/baserow/web-frontend/modules/core/pages/admin/users.vue")
  },
  {
    name: "admin-workspaces",
    path: "/admin/workspaces",
    component: () => import("/baserow/web-frontend/modules/core/pages/admin/workspaces.vue")
  },
  {
    name: "settings",
    path: "/workspace/:workspaceId/settings",
    component: () => import("/baserow/web-frontend/modules/core/pages/settings.vue"),
    children: [
  {
    name: "settings-members",
    path: "members",
    component: () => import("/baserow/web-frontend/modules/core/pages/settings/members.vue")
  },
  {
    name: "settings-invites",
    path: "invites",
    component: () => import("/baserow/web-frontend/modules/core/pages/settings/invites.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  }
]
  },
  {
    name: "admin-auth-providers",
    path: "/admin/auth-providers",
    meta: { ...(authProvidersuMb14F76shjkmDTzRgx9t1Byy96DUtu2UGSPdf2s0YIMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue")
  },
  {
    name: "admin-audit-log",
    path: "/admin/audit-log",
    meta: { ...(auditLoghW_1xgi9QvuDiwKn1VN8riwHG3scPWGWzYm_ix4l_45mEMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  },
  {
    name: "admin-data-scanner",
    path: "/admin/data-scanner",
    meta: { ...(dataScanner_456g9jC3fPyQ_h8Rdz0ov8pHnlbQ3UwPk_45kQsxyM9EaIMeta || {}), ...{"middleware":"staff"} },
    redirect: "/admin/data-scanner/scans",
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue"),
    children: [
  {
    name: "admin-data-scanner-scans",
    path: "scans",
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/scans.vue")
  },
  {
    name: "admin-data-scanner-results",
    path: "results",
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/results.vue")
  }
]
  },
  {
    name: "workspace-audit-log",
    path: "/workspace/:workspaceId/audit-log",
    component: () => import("/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  }
]
  },
  {
    name: "workspace-invitation",
    path: "/workspace-invitation/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/baserow/web-frontend/modules/core/pages/workspaceInvitation.vue")
  },
  {
    name: "workspace-subscription",
    path: "/plano/:workspaceId",
    meta: { ...(workspaceSubscriptionFEts0rEHl6Uz5DM7PwO3g1xaYeB7S90dSqMpNPxKhoAMeta || {}), ...{"middleware":["settings","authenticated","impersonate","settings","authenticated","impersonate"]} },
    component: () => import("/baserow/web-frontend/modules/core/pages/workspaceSubscription.vue")
  },
  {
    name: "template",
    path: "/template/:slug",
    component: () => import("/baserow/web-frontend/modules/core/pages/template.vue")
  },
  {
    name: "health-check",
    path: "/_health/:trailing()?",
    component: () => import("/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "notification-redirect",
    path: "/notification/:workspaceId/:notificationId",
    component: () => import("/baserow/web-frontend/modules/core/pages/notificationRedirect.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingIWNjSFyY6nPF_BVSHjJTVK5hBIMIe612LISdhdjMObUMeta || {},
    component: () => import("/baserow/web-frontend/modules/core/pages/onboarding.vue")
  },
  {
    name: "database-table",
    path: "/database/:databaseId/table/:tableId/:viewId?",
    meta: { ...(tablemTVQiEMlU14K5OtkWdYaGXkjm3tVCiQtx2LsdJnfk_QMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs","settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs"]} },
    component: () => import("/baserow/web-frontend/modules/database/pages/table.vue"),
    children: [
  {
    name: "database-table-row",
    path: "row/:rowId",
    component: () => import("/baserow/web-frontend/modules/core/components/RouterViewPlaceholder.vue")
  },
  {
    name: "database-table-open-webhooks",
    path: "webhooks",
    component: () => import("/baserow/web-frontend/modules/database/pages/table/webhooks.vue")
  },
  {
    name: "database-table-open-configure-data-sync",
    path: "configure-data-sync/:selectedPage?",
    component: () => import("/baserow/web-frontend/modules/database/pages/table/configureDataSync.vue")
  }
]
  },
  {
    path: "/api/docs",
    name: "database-api-docs-redirect",
    redirect: "/api-docs"
  },
  {
    path: "/api/docs/database/:databaseId",
    name: "database-api-docs-details-redirect",
    redirect: "/api-docs/database/:databaseId"
  },
  {
    name: "database-api-docs",
    path: "/api-docs",
    meta: { ...(APIDocsQg8DLE1eQadmdbWaqyCWLfVyuLfYC7LYtjxAWhrpEfoMeta || {}), ...{"middleware":["workspacesAndApplications","workspacesAndApplications"]} },
    alias: ["/api/docs"],
    component: () => import("/baserow/web-frontend/modules/database/pages/APIDocs.vue")
  },
  {
    name: "database-api-docs-detail",
    path: "/api-docs/database/:databaseId",
    meta: {"middleware":["workspacesAndApplications","workspacesAndApplications"]},
    component: () => import("/baserow/web-frontend/modules/database/pages/APIDocsDatabase.vue")
  },
  {
    name: "database-table-form",
    path: "/form/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/baserow/web-frontend/modules/database/pages/form.vue")
  },
  {
    name: "database-public-grid-view",
    path: "/public/grid/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-gallery-view",
    path: "/public/gallery/:slug",
    component: () => import("/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-view-auth",
    path: "/public/auth/:slug",
    meta: { ...(publicViewLoginKVr__4_4550hOAzx59hzmTOxTyOoxVZ9_zBS_rYEgf3REMeta || {}), ...{"layout":"login"} },
    component: () => import("/baserow/web-frontend/modules/database/pages/publicViewLogin.vue")
  },
  {
    name: "dashboard-application",
    path: "/dashboard/:dashboardId",
    meta: { ...(dashboardj_EB_Il_Josd1bmESPebSB_f1OHa9fmmpy9FJpVgJ8MMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","dashboardLoading","settings","authenticated","workspacesAndApplications","dashboardLoading"]} },
    component: () => import("/baserow/web-frontend/modules/dashboard/pages/dashboard.vue")
  },
  {
    name: "builder-page",
    path: "/builder/:builderId/page/:pageId",
    meta: { ...(pageEditorsZQzKZbfo1k6Gkb3KmAv47XyUSeGMH4gZEDTslcIlcMMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs"]} },
    component: () => import("/baserow/web-frontend/modules/builder/pages/pageEditor.vue")
  },
  {
    name: "application-builder-page",
    path: "/:pathMatch(.*)*",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "builder-health-check",
    path: "/_health",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "application-builder-preview",
    path: "/builder/:builderId/preview/:pathMatch(.*)*",
    component: () => import("/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/:automationId/workflow/:workflowId",
    meta: { ...(automationWorkflowhCau8gUYQvK_45lD1Mi3_M_K9P71VIvnTqxqIf_ZfEsMMMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue")
  },
  {
    name: "premium-root",
    path: "",
    meta: { ...(rootOhF6Qibb72QLTvpk0YXBFRpkCuwCr_OzDVjK8lo3riYMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/baserow/premium/web-frontend/modules/baserow_premium/pages/root.vue"),
    children: [
  {
    name: "admin-licenses",
    path: "/admin/licenses",
    meta: { ...(licensesmzDgoW2_45voHJynKYUXMaKeoVi1FLMyphQLy6TQ0AOgAMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue")
  },
  {
    name: "admin-license",
    path: "/admin/license/:id",
    meta: { ...(licensec24WGnNG4lqaJzipKZtk5QEcsxnOi_Dq1t1Fpe8C1DAMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue")
  }
]
  },
  {
    name: "database-public-kanban-view",
    path: "/public/kanban/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-calendar-view",
    path: "/public/calendar/:slug",
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-timeline-view",
    path: "/public/timeline/:slug",
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  }
]